const API_URL = process.env.REACT_APP_API_URL;

// POST valeur d'un champ personnalisé pour un ticket
export async function postChampValeur(champId, ticketId, valeur) {
  const response = await fetch(`${API_URL}/champ/${champId}/valeur/ticket/${ticketId}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ champ: { valeur } }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Erreur lors de l'enregistrement du champ ${champId}`);
  }

  return response.json();
}

// GET toutes les valeurs de champs custom d'un ticket
export async function getChampValeursTicket(ticketId) {
  const response = await fetch(`${API_URL}/champ/valeur/ticket/${ticketId}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la récupération des valeurs");
  }

  return response.json();
}

// PUT mise à jour d'une valeur de champ custom pour un ticket
export async function putChampValeur(champId, ticketId, valeur) {
  const response = await fetch(`${API_URL}/champ/${champId}/valeur/ticket/${ticketId}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ champ: { valeur } }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Erreur lors de la mise à jour du champ ${champId}`);
  }

  return response.json();
}

// GET all custom fields
export async function getChamps() {
  const response = await fetch(`${API_URL}/champ`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération des champs");
  }

  return response.json();
}

// GET custom field by ID
export async function getChampById(id) {
  const response = await fetch(`${API_URL}/champ/${id}`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération du champ");
  }

  return response.json();
}

// GET field types
export async function getFieldTypes() {
  const response = await fetch(`${API_URL}/champ/types`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération des types de champs");
  }

  return response.json();
}

// GET statuts (generic endpoint)
export async function getFieldApplyStatuses() {
  const response = await fetch(`${API_URL}/statuts`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération des statuts d'application");
  }

  return response.json();
}

// GET field options
export async function getFieldOptions(id) {
  const response = await fetch(`${API_URL}/champ/${id}/options`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la récupération des options");
  }

  return response.json();
}

// POST create field option
export async function createFieldOption(id, optionData) {
  const response = await fetch(`${API_URL}/champ/${id}/options`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ champ: { valeur: optionData.value, label: optionData.label } }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la création de l'option");
  }

  return response.json();
}

// PUT update field option
export async function updateFieldOption(customFieldId, optionId, optionData) {
  const response = await fetch(`${API_URL}/champ/${customFieldId}/option/${optionId}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ champ: { valeur: optionData.value, label: optionData.label } }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la mise à jour de l'option");
  }

  return response.json();
}

// DELETE field option
export async function deleteFieldOption(customFieldId, optionId) {
  const response = await fetch(`${API_URL}/champ/${customFieldId}/option/${optionId}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la suppression de l'option");
  }

  return response.json();
}

// PUT update field value
export async function updateFieldValue(customFieldId, valueId, valueData) {
  const response = await fetch(`${API_URL}/champ/${customFieldId}/valeur/${valueId}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(valueData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la mise à jour de la valeur");
  }

  return response.json();
}

// DELETE field value
export async function deleteFieldValue(customFieldId, valueId) {
  const response = await fetch(`${API_URL}/champ/${customFieldId}/valeur/${valueId}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la suppression de la valeur");
  }

  return response.json();
}

// POST create custom field
export async function createChamp(champData) {
  const response = await fetch(`${API_URL}/champ`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ champ: champData }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la création du champ");
  }

  return response.json();
}

// PUT update custom field
export async function updateChamp(id, champData) {
  const response = await fetch(`${API_URL}/champ/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ champ: champData }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la mise à jour du champ");
  }

  return response.json();
}

// DELETE custom field
export async function deleteChamp(id) {
  const response = await fetch(`${API_URL}/champ/${id}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de la suppression du champ");
  }

  return response.json();
}

// POST add clients to field
export async function addClientsToField(id, clientIds) {
  const response = await fetch(`${API_URL}/champ/${id}/clients`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ champ: { clients: clientIds } }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors de l'ajout des clients");
  }

  return response.json();
}

// DELETE remove clients from field
export async function removeClientsFromField(id, clientIds) {
  const response = await fetch(`${API_URL}/champ/${id}/clients`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ champ: { clients: clientIds } }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors du retrait des clients");
  }

  return response.json();
}
